import Container from '@zenbusiness/zui/Container';
import { superstyled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

export const InvoicePaymentsContainer = superstyled({
  name: 'InvoicePayments',
  slot: 'container',
  tag: Container,
  propsAdded: {
    maxWidth: 'sm',
  },
  styles: ({ theme }) => ({
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(6),
  }),
});

export const InvoicePaymentsCompanyName = superstyled({
  name: 'InvoicePayments',
  slot: 'companyName',
  tag: Text,
  propsAdded: {
    color: 'secondary',
    size: 'xs',
    uppercase: true,
    weight: 'medium',
  },
});

export const InvoicePaymentsSubtitle = superstyled({
  name: 'InvoicePayments',
  slot: 'subtitle',
  tag: Text,
  propsAdded: {
    color: 'secondary',
    component: 'p',
    size: 'md',
  },
  styles: ({ theme }) => ({
    marginTop: theme.spacing(1),
  }),
});

export const InvoicePaymentsEmptyState = superstyled({
  name: 'InvoicePayments',
  slot: 'emptyState',
  tag: Text,
  propsAdded: {
    color: 'secondary',
    component: 'p',
    size: 'md',
  },
});
